module.exports = __webpack_public_path__ + "static/media/logo.147240dc.png";